App.filter('healthInsuranceTypeToNumberFilter', function () {
    var dictionary = {
        'BASIC': 1,
        'EXPANDED': 2,
        'FULL': 3,
        'VIP': 4,
        'REHABILITATION': 5,
        'SENIOR': 6,
    };

    return function (el) {
        if (!el) {
            return el;
        }

        return dictionary[el] || el;
    };
});
